import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=56e5a194&scoped=true&"
import script from "./QuotesList.vue?vue&type=script&lang=js&"
export * from "./QuotesList.vue?vue&type=script&lang=js&"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=56e5a194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5a194",
  null
  
)

export default component.exports